import { useState, useEffect } from "react";
import {
  Flex,
  Heading,
  Input,
  Button,
  Stack,
  Box,
  Text,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import AuthService from "../../services/auth.service";
import { useHistory } from "react-router-dom";
import "./login.css";

const MfaVerify = () => {
  const history = useHistory();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!AuthService.getMfaToken()) {
      history.push("/login");
    }
  }, [history]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    AuthService.verifyMfaLogin(otp).then(
      () => {
        history.push("/statistics");
      },
      (err) => {
        setLoading(false);
        setError(
          (err.response && err.response.data && err.response.data.message) ||
            "Verification failed. Please try again."
        );
      }
    );
  };

  return (
    <Flex
      flexDirection="column"
      width="100wh"
      height="100vh"
      backgroundColor="gray.200"
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
        p={5}
        backgroundColor="white"
        boxShadow="md"
      >
        <Heading color="teal.400" size="md">
          Two-factor authentication
        </Heading>
        <Box minW={{ base: "90%", md: "468px" }}>
          <form onSubmit={handleSubmit}>
            <Stack spacing={4} p="1rem" backgroundColor="whiteAlpha.900">
              <Text fontSize="sm" textAlign="center">
                Enter the current code from your authenticator app.
              </Text>
              <FormControl isRequired>
                <FormLabel fontSize="sm">Authentication code</FormLabel>
                <Input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  placeholder="123456"
                  value={otp}
                  onChange={(e) => setOtp(e.currentTarget.value.trim())}
                  autoFocus
                />
              </FormControl>
              {error ? (
                <Text color="red.500" fontSize="sm" textAlign="center">
                  {error}
                </Text>
              ) : null}
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="teal"
                width="full"
                isLoading={loading}
              >
                Verify
              </Button>
            </Stack>
          </form>
        </Box>
      </Stack>
    </Flex>
  );
};

export default MfaVerify;
